import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Layout/Navbar';
import AnimatedRoutes from './AnimatedRoutes'; // Toutes les routes avec animation

const theme = createTheme({
  palette: {
    primary: {
      main: '#014E9A',
      light: '#3A84CE',
      dark: '#013F7E',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f7c21d',
      light: '#ffd54f',
      dark: '#d4a300',
      contrastText: '#163047',
    },
    background: {
      default: '#eef5fa',
      paper: '#ffffff',
    },
    text: {
      primary: '#163047',
      secondary: '#6f7b86',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <div className="App">
            {/* Navbar reste fixe */}
            <Navbar />

            {/* Routes animées */}
            <AnimatedRoutes />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
